// Edit this file to add, remove, reorder, or update faculty members for this department.
const facultyData = {
  "hod": {
    "id": "f-k-s-pujari",
    "name": "Dr. K S Pujari",
    "designation": "Professor & Head of Department",
    "role": "Professor & Head of Department",
    "qualification": "M.Tech., Ph.D.",
    "qualifications": "M.Tech., Ph.D.",
    "image": "/FacultyCImages/DR_k_s_pujar_MECH.jpeg",
    "email": "ksp@klsvdit.edu.in",
    "phone": "+91 94484 08457",
    "showPhone": true,
    "experience": "26 years",
    "description": "Dr. K. S. Pujari (M.Tech., Ph.D.., MIE) is Professor and Head of Mechanical Engineering at KLS VDIT, Haliyal, with over 26 years of teaching and 19 years of research experience. His expertise includes welding technology, advanced manufacturing, materials characterization, and process optimization. He has secured research funding exceeding ₹60 lakh, 10 journal publications, guided as Ph.D. Jury member for various Industrial awards and actively promotes industry-academia collaboration and innovation.",
    "bio": "Dr. K. S. Pujari (M.Tech., Ph.D.., MIE) is Professor and Head of Mechanical Engineering at KLS VDIT, Haliyal, with over 26 years of teaching and 19 years of research experience. His expertise includes welding technology, advanced manufacturing, materials characterization, and process optimization. He has secured research funding exceeding ₹60 lakh, 10 journal publications, guided as Ph.D. Jury member for various Industrial awards and actively promotes industry-academia collaboration and innovation.",
    "specializations": [
      "Welding of Aerospace-Grade Alloys,",
      "Additive Manufacturing,",
      "Evaluation of Welded Joints,",
      "Cyber-Physical Systems and Intelligent Welding Automation"
    ],
    "areas": [
      "Welding of Aerospace-Grade Alloys,",
      "Additive Manufacturing,",
      "Evaluation of Welded Joints,",
      "Cyber-Physical Systems and Intelligent Welding Automation"
    ],
    "courses": [
      "Material Science",
      "Control Engineering",
      "Optimization Techniques",
      "Production And Operations Management"
    ],
    "publications": 9,
    "projects": 4,
    "linkedin": "https://www.linkedin.com/in/dr-k-s-pujari-8a8bb28b/",
    "irins": "https://klsvdit.irins.org/profile/210833",
    "recognition": [
      "Secured over ₹60 lakh Research project work as Principal Investigator (PI)/Co-Principal Investigator (PI)",
      "Member (Member of the Institution of Engineers (MIE)) of Institution of Engineers India (IEI) professional bodies",
      "Jury member for various Industrial awards",
      "Successfully Completed on May 29th 2021 an online non-credit course offered through Coursera on \"Material Processing\" authorized by Georgia Institute of Technology, North Avenue, Atlanta, GA 30332894.2000",
      "Successfully Completed on June 3rd 2021 an online non-credit course \"Deep learning Artificial Intelligence (AI)\" offered through Coursera",
      "Successfully Completed on December 2025, All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certificate Programme in Cyber Physical System"
    ]
  },
  "members": [
    {
      "id": "f-b-b-patil",
      "name": "Mr. B B Patil",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/basavaraj_b_patil_MECH.jpeg",
      "email": "bbp@klsvdit.edu.in",
      "phone": "+91 79757 31131",
      "showPhone": false,
      "experience": "32 years",
      "description": "Mr. B. B. Patil is an Assistant Professor in the Department of Mechanical Engineering at KLS VDIT and has been serving the institution since 2008. His areas of interest include Total Productive Maintenance and Total Quality Management. He is committed to teaching, professional development, and fostering quality practices in engineering education.",
      "bio": "Mr. B. B. Patil is an Assistant Professor in the Department of Mechanical Engineering at KLS VDIT and has been serving the institution since 2008. His areas of interest include Total Productive Maintenance and Total Quality Management. He is committed to teaching, professional development, and fostering quality practices in engineering education.",
      "specializations": [
        "Total Productive Maintenance",
        "Total Quality Management"
      ],
      "areas": [
        "Total Productive Maintenance",
        "Total Quality Management"
      ],
      "courses": [
        "Industrial Management & Entrepreneurship",
        "Theory Of Machines",
        "Non Traditional Machining",
        "Mechanical Measurements & Metrology"
      ],
      "publications": 2,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/b-b-patil-47845064?trk=contact-info",
      "irins": "https://klsvdit.irins.org/profile/248982",
      "recognition": [
        "A member of Institution of Engineers India (IEI) Member"
      ]
    },
    {
      "id": "f-naveen-s-hiremath",
      "name": "Mr. Naveen S Hiremath",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/naveen_hiremath_MECH.jpeg",
      "email": "nsh@klsvdit.edu.in",
      "phone": "+91 90363 95119",
      "showPhone": false,
      "experience": "11 years",
      "description": "Mr. Naveen S Hiremath serves as an Assistant Professor at KLS VDIT, Haliyal. His research interests focus on heat transfer, machine learning, and their applications in the energy domain. He is a life member of the Institution of Engineers (India) and has completed the AICTE QIP PG Certification Course in Machine Learning.",
      "bio": "Mr. Naveen S Hiremath serves as an Assistant Professor at KLS VDIT, Haliyal. His research interests focus on heat transfer, machine learning, and their applications in the energy domain. He is a life member of the Institution of Engineers (India) and has completed the AICTE QIP PG Certification Course in Machine Learning.",
      "specializations": [
        "Heat Transfer",
        "Energy Systems",
        "Machine Learning",
        "Thermodynamics"
      ],
      "areas": [
        "Heat Transfer",
        "Energy Systems",
        "Machine Learning",
        "Thermodynamics"
      ],
      "courses": [
        "Thermodynamics",
        "Introduction To Python",
        "Introduction To Artificial Intelligence (AI)",
        "Fluid Mechanics"
      ],
      "publications": 3,
      "projects": 2,
      "linkedin": "https://www.linkedin.com/in/naveen-hiremath-70520071/",
      "irins": "https://klsvdit.irins.org/profile/249075",
      "recognition": [
        "Received Patent Grant for \"Inverse diffusion flame burner with different angled fuel jets and swirl\"",
        "Completed 6 Month All India Council for Technical Education (AICTE)-Quality Improvement Programme (QIP)-Postgraduate (PG) Certificate Programme in 'Machine Learning' from Indian Institute of Information Technology (IIIT) Raichur",
        "Completed 3 Month Course on \"Machine Learning\" Offered by Indian Institute of Technology (IIT) Dharwad",
        "2 Years of Industrial Experience in the field of Heating, Ventilation, and Air Conditioning (HVAC)"
      ]
    },
    {
      "id": "f-shankar-badiger",
      "name": "Dr. Shankar Badiger",
      "designation": "Associate Professor",
      "role": "Associate Professor",
      "qualification": "M.Tech., Ph.D.",
      "qualifications": "M.Tech., Ph.D.",
      "image": "/FacultyCImages/DR_shankar_badiger_MECH.jpeg",
      "email": "snb@klsvdit.edu.in",
      "phone": "+91 98863 72913",
      "showPhone": false,
      "experience": "21 years",
      "description": "Dr. Shankar Badiger is an Associate Professor in Mechanical Engineering at KLS VDIT, Haliyal. He holds a Ph.D. from VTU and has over two decades of academic experience. His research spans renewable energy and sustainable engineering. He has published extensively, secured multiple patents, and guided award-winning KSCST-funded student innovation projects.",
      "bio": "Dr. Shankar Badiger is an Associate Professor in Mechanical Engineering at KLS VDIT, Haliyal. He holds a Ph.D. from VTU and has over two decades of academic experience. His research spans renewable energy and sustainable engineering. He has published extensively, secured multiple patents, and guided award-winning KSCST-funded student innovation projects.",
      "specializations": [
        "Combustion and Heat transfer",
        "Utilisation of solar energy",
        "Air jet impingement"
      ],
      "areas": [
        "Combustion and Heat transfer",
        "Utilisation of solar energy",
        "Air jet impingement"
      ],
      "courses": [
        "Applied Thermodynamics",
        "Turbomachines",
        "Computer Aided Engineering Drawing",
        "Introduction To Mechanical Engineering"
      ],
      "publications": 8,
      "projects": 8,
      "linkedin": "https://www.linkedin.com/in/shankar-badiger-61181a129/",
      "irins": "https://klsvdit.irins.org/profile/248995",
      "recognition": [
        "Recognition as Research Supervisor by Visvesvaraya Technological University (VTU)",
        "Received the 'Best Project of the Year' Award from Karnataka State Council for Science and Technology (KSCST), Bengaluru, on three occasions for outstanding student innovation projects",
        "Published- 10 patents",
        "Granted - 01 patent"
      ]
    },
    {
      "id": "f-deepak-v-lokare",
      "name": "Mr. Deepak V Lokare",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/deepak_lokare_MECH.jpeg",
      "email": "dvl@klsvdit.edu.in",
      "phone": "+91 94820 24433",
      "showPhone": false,
      "experience": "15 years",
      "description": "Mr. Deepak Lokare is an experienced academician serving as an Assistant Professor in the Department of Mechanical Engineering, with 15 years of teaching experience. His academic interests and expertise lie in the areas of Design Engineering and Production Engineering. Alongside his academic responsibilities, he has been serving as the Hostel In-Charge for the last four years, playing a significant role in student support and administration.",
      "bio": "Mr. Deepak Lokare is an experienced academician serving as an Assistant Professor in the Department of Mechanical Engineering, with 15 years of teaching experience. His academic interests and expertise lie in the areas of Design Engineering and Production Engineering. Alongside his academic responsibilities, he has been serving as the Hostel In-Charge for the last four years, playing a significant role in student support and administration.",
      "specializations": [
        "Analysis",
        "Design and Optimization using Taguchi technique"
      ],
      "areas": [
        "Analysis",
        "Design and Optimization using Taguchi technique"
      ],
      "courses": [
        "Theory Of Machines",
        "Research Methodology And Intellectual Property Rights (IPR)",
        "Management And Entrepreneurship",
        "Operation Research"
      ],
      "publications": 3,
      "projects": 3,
      "linkedin": "https://linkedin.com/in/prof-deepak-lokare-41b773224",
      "irins": "https://share.google/bnbuyvKt3Yw8Q4kNK",
      "recognition": [
        "Member of professional bodies including Institution of Engineers India (IEI)",
        "A member of Indian Society for Technical Education (ISTE)",
        "Received Karnataka State Council for Science and Technology (KSCST) project grants",
        "Regular Blood donor for 13 continuous years"
      ]
    },
    {
      "id": "f-gururaj-r-sattigeri",
      "name": "Mr. Gururaj R Sattigeri",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/gururaj_sattigeri_MECH.jpeg",
      "email": "grs@klsvdit.edu.in",
      "phone": "+91 94488 38507",
      "showPhone": false,
      "experience": "35 years",
      "description": "Mr. Gururaj R. Sattigeri is a Senior Faculty Member in Mechanical Engineering at KLS VDIT. He holds an M.Tech. in Manufacturing Engineering from IIT Bombay (2000) and completed the AICTE-QIP PG Program in Cyber Physical Systems (2025). His interests include manufacturing, AI applications, thermal engineering, and engineering education.",
      "bio": "Mr. Gururaj R. Sattigeri is a Senior Faculty Member in Mechanical Engineering at KLS VDIT. He holds an M.Tech. in Manufacturing Engineering from IIT Bombay (2000) and completed the AICTE-QIP PG Program in Cyber Physical Systems (2025). His interests include manufacturing, AI applications, thermal engineering, and engineering education.",
      "specializations": [
        "Artificial intelligence and Engineering"
      ],
      "areas": [
        "Artificial intelligence and Engineering"
      ],
      "courses": [
        "Mechanics Of Materials",
        "Computer-Aided Engineering Drawing (CAED)",
        "Finite Element Method",
        "Biology For Engineers"
      ],
      "publications": 3,
      "projects": 0,
      "linkedin": "https://linkedin.com/in/gururaj-sattigeri-38442069",
      "irins": "https://klsvdit.irins.org/profile/248951",
      "recognition": [
        "M. Tech from Indian Institute of Technology (IIT), Bombay, All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) in Cyber Physical Systems from Indian Institute of Information Technology (IIIT), Dharwad",
        "All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) in Cyber Physical Systems from Indian Institute of Information Technology (IIIT) Dharwad in 2025"
      ]
    },
    {
      "id": "f-anant-g-joshi",
      "name": "Dr. Anant G Joshi",
      "designation": "Associate Professor",
      "role": "Associate Professor",
      "qualification": "M.Tech., Ph.D.",
      "qualifications": "M.Tech., Ph.D.",
      "image": "/FacultyCImages/DR_anant_joshi_MECH.jpeg",
      "email": "agj@klsvdit.edu.in",
      "phone": "+91 74110 39447",
      "showPhone": false,
      "experience": "14 years",
      "description": "Dr. Anant G. Joshi is an Associate Professor in the Department of Mechanical Engineering at KLS VDIT. He holds a Ph.D. in Composite Materials and completed his postgraduate research at the Automotive Research Association of India (ARAI), Pune. His interests include Composite Materials, Additive Manufacturing, Product Design and Development, and Smart Materials.",
      "bio": "Dr. Anant G. Joshi is an Associate Professor in the Department of Mechanical Engineering at KLS VDIT. He holds a Ph.D. in Composite Materials and completed his postgraduate research at the Automotive Research Association of India (ARAI), Pune. His interests include Composite Materials, Additive Manufacturing, Product Design and Development, and Smart Materials.",
      "specializations": [
        "Composite Materials",
        "Additive Manufacturing",
        "Product Design and Development",
        "Smart Materials"
      ],
      "areas": [
        "Composite Materials",
        "Additive Manufacturing",
        "Product Design and Development",
        "Smart Materials"
      ],
      "courses": [
        "Design Of Machine Elements",
        "Product Design And Development",
        "Smart Materials And Systems",
        "Non Traditional Machining Processes"
      ],
      "publications": 6,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/dr-anant-joshi-24772324a/",
      "irins": "https://klsvdit.irins.org/profile/249045",
      "recognition": [
        "Recognised as research supervisor in the Mechanical Engineering Sciences by Visvesvaraya Technological University (VTU), Belagavi",
        "Secured first place in poster presentation held at Shri Dharmasthala Manjunatheshwara (SDM) University Dharwad on the topic of sustainable composite materials",
        "Served as and recognised as volunteer of Tata ready engineer program in 2017"
      ]
    },
    {
      "id": "f-gururaj-hatti",
      "name": "Dr. Gururaj Hatti",
      "designation": "Associate Professor & Dean(Academics)",
      "role": "Associate Professor & Dean(Academics)",
      "qualification": "M.Tech., Ph.D.",
      "qualifications": "M.Tech., Ph.D.",
      "image": "/FacultyCImages/DR_gururaj_hatti_MECH.jpeg",
      "email": "gnh@klsvdit.edu.in",
      "phone": "+91 99723 96543",
      "showPhone": false,
      "experience": "13 years",
      "description": "Dr. Gururaj Hatti faculty in the Department of Mechanical Engineering and Dean （Academics） at KLS VDIT. His research focuses on Biomaterials, Advanced Green MMC, Additive Manufacturing. He has supervising 3 Ph.D. scholars and is a member of ISTE,MIE,MRSI,KSTA, and more.",
      "bio": "Dr. Gururaj Hatti faculty in the Department of Mechanical Engineering and Dean （Academics） at KLS VDIT. His research focuses on Biomaterials, Advanced Green MMC, Additive Manufacturing. He has supervising 3 Ph.D. scholars and is a member of ISTE,MIE,MRSI,KSTA, and more.",
      "specializations": [
        "Biomaterials",
        "Advanced Green Metal Matrix Composites (MMC)",
        "Additive Manufacturing"
      ],
      "areas": [
        "Biomaterials",
        "Advanced Green Metal Matrix Composites (MMC)",
        "Additive Manufacturing"
      ],
      "courses": [
        "Operation Management",
        "Advanced Materials Technology",
        "Additive Manufacturing",
        "Project Management"
      ],
      "publications": 26,
      "projects": 1,
      "linkedin": "https://linkedin.com/in/gururaj-hatti-58b0392b/",
      "irins": "https://klsvdit.irins.org/profile/123415",
      "recognition": [
        "Patent No. [576601] Inverse diffusion flame burner with different angled fuel jets and swirl- Granted",
        "Sanction of Student Project - 47th Series: Year 2023-2024, Project Proposal Reference No.: 47S_BE_0470, Project Proposal entitled: GREEN METAL MATRIX COMPOSITES: REPURPOSING DEBRIS FOR ENGINEERING PURPOSES, Sanctioned Amount (in Rs.): 5,500 by Karnataka State Council for Science and Technology (Karnataka State Council for Science and Technology (KSCST))",
        "Patent Published/ Granted",
        "Title of the invention: Investigation on Sliding Wear Behaviour of Zinc Alloy Reinforced with Nano B4c Composite, Application No.202341066233 A, Publication Date: 20/10/2023",
        "Title of the invention: Modified Domestic LPG Cooking Stove, Application No.202441019056 A, Publication Date: 29/03/2024",
        "Title of the invention: Inverse diffusion flame burner with different angled fuel jets and swirl, Application No.202441027549 A, Publication Date: 12/04/2024. Patent No.: 576601 - Granted",
        "Title of the invention: Portable Domestic Solar Vegetable Dryer with Swirl, Application No.202441034100 A, Publication Date: 10/05/2024",
        "Title of the invention: Teacup and Wick Type Floating Solar Still, Application No.202441055442, Publication Date: 26/07/2024",
        "Patent published on \"A floating wick type solar desalination system integrated with an artificial neural network\". 17/01/2025. No. 202541001679 A- India",
        "Patent published on \"A Jig designed for drilling on the cylindrical surface of a hub-like component\" Publication Date: 13/06/2025, Application No.202541050593",
        "Patent published on \"Solar Assisted Air Cooler with Mud Clay Pot Pieces\" Publication Date: 27/06/2025, Application No.202541058424",
        "Patent published on \" A modified inverse diffusion flame jet burner with 90 degree fuel jets\" Publication Date: 22/08/2025, Application No.202541074406",
        "Patent published on \"Solar PV-Powered Desalination System with Water-Cooled Condenser\" Publication Date: 03/10/2025, Application No.202541085873",
        "Patent published on \"AI-Powered Crop Monitoring Device in Agriculture\" Publication Date: 24/10/2025, Application No.202541083949"
      ]
    },
    {
      "id": "f-santosh-savanur",
      "name": "Mr. Santosh Savanur",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/santosh_savanur_MECH.jpeg",
      "email": "sks@klsvdit.edu.in",
      "phone": "+91 96116 81828",
      "showPhone": false,
      "experience": "13 years",
      "description": "Mr.Santosh Savanur working as the Assistant Professor in the Department of Mechanical Engineering since from 2013.His reserch focuses on Vibration,Condition monitoring and Composite material.He has guided 15 UG Projects.He is the member of ISTE and IEI.",
      "bio": "Mr.Santosh Savanur working as the Assistant Professor in the Department of Mechanical Engineering since from 2013.His reserch focuses on Vibration,Condition monitoring and Composite material.He has guided 15 UG Projects.He is the member of ISTE and IEI.",
      "specializations": [
        "Vibration",
        "Condition Monitoring",
        "Composite Material"
      ],
      "areas": [
        "Vibration",
        "Condition Monitoring",
        "Composite Material"
      ],
      "courses": [
        "Engineering Drawing",
        "Python Programming",
        "Finite Element Method",
        "Innovation And Design Thinking"
      ],
      "publications": 5,
      "projects": 4,
      "linkedin": "https://in.linkedin.com/in/santosh-savanur-2aa6891b2",
      "irins": "https://klsvdit.irins.org/profile/249060",
      "recognition": [
        "Co-Principal Investigator for a research project funded by Vision Group on Science and Technology (VGST) with financial support of ₹20 lakh",
        "Secured First Rank and Gold Medal in M.tech from Visvesvaraya Technological University, Belagavi",
        "Completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certificate Program in Cyber Security from Indian Institute of Information Technology (IIIT)-Dharwad",
        "Successfully guided 3 Karnataka State Council for Science and Technology (KSCST)-funded student projects",
        "Completed Virtual Learning Centre Initiative (VLCI)",
        "Faculty Training Program on Flow Principles and Consultancy Principles organized by Mizuho India Japan Study Centre (Ministry of International Joint Skill Centre (MIJSC)) @ Indian Institute of Management, Bangalore"
      ]
    },
    {
      "id": "f-rajat-acharya",
      "name": "Mr. Rajat Acharya",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/rajat_acharya_MECH.jpeg",
      "email": "rra@klsvdit.edu.in",
      "phone": "+91 89048 59505",
      "showPhone": false,
      "experience": "13 years",
      "description": "Mr. Rajat Acharya is an academician, researcher, and training leader with over 13 years of experience in engineering education, industry collaboration, and workforce development. He specializes in curriculum design, student employability, accreditation support, research, industry partnerships, and stakeholder engagement, driving innovation, skill enhancement, and institutional excellence across academia and industry.",
      "bio": "Mr. Rajat Acharya is an academician, researcher, and training leader with over 13 years of experience in engineering education, industry collaboration, and workforce development. He specializes in curriculum design, student employability, accreditation support, research, industry partnerships, and stakeholder engagement, driving innovation, skill enhancement, and institutional excellence across academia and industry.",
      "specializations": [
        "Supply Chain Management and Operations Optimization",
        "Combustion Systems and Flame Burner Design",
        "Hydraulics and Pneumatic Systems Engineering",
        "Computational Wind Flow Analysis and Aerodynamic Studies"
      ],
      "areas": [
        "Supply Chain Management and Operations Optimization",
        "Combustion Systems and Flame Burner Design",
        "Hydraulics and Pneumatic Systems Engineering",
        "Computational Wind Flow Analysis and Aerodynamic Studies"
      ],
      "courses": [
        "Biology For Engineers",
        "Computer Integrated Manufacturing",
        "Computer-Aided Engineering (CAE) And Machine Design",
        "Robotics And Automation"
      ],
      "publications": 1,
      "projects": 4,
      "linkedin": "https://www.linkedin.com/in/rajat-acharya-a1837933/",
      "irins": "https://klsvdit.irins.org/profile/249050",
      "recognition": [
        "Completed the All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certificate Program in Cybersecurity at Indian Institute of Information Technology (IIIT) Dharwad (2024-25).",
        " Recognized by Visvesvaraya Technological University (VTU)-Bosch Rexroth Centre of Competence, Mysuru for delivering training programs on Hydraulics and Pneumatics,",
        "Honored with the Director Excellence Award at the All India Council for Technical Education (AICTE)-EduSkills Connect for outstanding contributions to training, skill development, and industry-academia collaboration,",
        "Received the Best Paper Award at the International Conference on Sustainable Solutions in Engineering and Technology (SSET) for research contributions in agricultural innovation and sustainable engineering solutions,",
        "Active Member of the Indian Society for Technical Education (A member of Indian Society for Technical Education (ISTE))",
        "In-Charge, Royal Enfield Training Centre, Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) (2026-Present): Leading the operations and student engagement activities of the Royal Enfield Training Centre, a state-of-the-art facility serving North Karnataka and Goa, and the only such centre established in an educational institution in Karnataka",
        "Resource Person, Visvesvaraya Technological University (VTU) Regional Centre, Mysuru (2016, 2018 &",
        "Delivered Short Term Training Programme (STTP) sessions on Hydraulics and Pneumatics",
        "Director - Training & Development, Karnatak Law Society (KLS) Vishwanathrao Deshpande Institute of Technology (VDIT) (2020-2025): Led training, placement, and industry engagement initiatives",
        "Best Paper Award (2025): Honored at the International Conference on Sustainable Solutions in Engineering and Technology (SSET) for research in agricultural innovation at Basaveshwar Engineering College (BEC) Bagalkote",
        "Successfully filed 5 patents in Innovation & Intellectual Property (2024-2025), with 1 patent already granted",
        "Trainee, Toyota Kirloskar Motors (2011-2012): Worked in supply chain, inventory management, and manufacturing operations"
      ]
    },
    {
      "id": "f-gurunath-mewundi",
      "name": "Mr. Gurunath Mewundi",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/gurunath_mewundi_MECH.jpeg",
      "email": "gmm@klsvdit.edu.in",
      "phone": "+91 81055 34380",
      "showPhone": false,
      "experience": "21 years",
      "description": "Mr. Gurunath Mewundi is an Assistant Professor in the Department of Mechanical Engineering at KLS VDIT. He has been serving the institution since 2014 and is currently pursuing a Ph.D. in Friction Welding. With 10 years of industrial experience, he has held managerial positions at WABCO-TVS India Ltd. and Automotive Axles Ltd.",
      "bio": "Mr. Gurunath Mewundi is an Assistant Professor in the Department of Mechanical Engineering at KLS VDIT. He has been serving the institution since 2014 and is currently pursuing a Ph.D. in Friction Welding. With 10 years of industrial experience, he has held managerial positions at WABCO-TVS India Ltd. and Automotive Axles Ltd.",
      "specializations": [
        "Computer Numerical Control (CNC) Machining",
        "Friction Welding",
        "3D (Three-Dimensional) Printing",
        "Tooling Design"
      ],
      "areas": [
        "Computer Numerical Control (CNC) Machining",
        "Friction Welding",
        "3D (Three-Dimensional) Printing",
        "Tooling Design"
      ],
      "courses": [
        "Machining Science And Metrology",
        "Additive Manufacturing",
        "Manufacturing Processes",
        "Material Science"
      ],
      "publications": 4,
      "projects": 3,
      "linkedin": "",
      "irins": "",
      "recognition": [
        "Certified Virtual Learning Centre Initiative (VLCI) course on Lean Manufacturing Practices (LMP) program - An Indian Institute of Management (IIM) Bangalore and Ministry of International Joint Skill Centre (MIJSC) Joint Venture (JV) program with highest score",
        "Completed Lean Manufacturing Practices (LMP) program - An Indian Institute of Management (IIM) Bangalore and Ministry of International Joint Skill Centre (MIJSC) Joint Venture (JV) program with highest score",
        "Member of the Institution of Engineers (MIE) membership in Institution of Engineers India (IEI)",
        "Guided students in Visvesvaraya Technological University (VTU) sanctioned projects & Industrial projects",
        "Consultancy in Computer Numerical Control (CNC) machining",
        "Mentored the students in \"The Ready Engineer\" Program, a joint initiative of Belgaum Foundry Cluster and Tata Technologies",
        "Published 3 patents"
      ]
    },
    {
      "id": "f-ranganath-n-patil",
      "name": "Mr. Ranganath N Patil",
      "designation": "Associate professor",
      "role": "Associate professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/ranganath_patil_MECH.jpeg",
      "email": "rnp@klsvdit.edu.in",
      "phone": "+91 99865 97762",
      "showPhone": false,
      "experience": "35 years",
      "description": "Mr. Ranganath N. Patil is an Associate Professor in the Department of Mechanical Engineering at KLS VDIT, Haliyal, with 35 years of teaching experience. Specializing in Thermal Engineering, he has established Thermal Engineering laboratories, published research papers in international journals and conferences, and contributed significantly through academic, administrative, and institutional development activities.",
      "bio": "Mr. Ranganath N. Patil is an Associate Professor in the Department of Mechanical Engineering at KLS VDIT, Haliyal, with 35 years of teaching experience. Specializing in Thermal Engineering, he has established Thermal Engineering laboratories, published research papers in international journals and conferences, and contributed significantly through academic, administrative, and institutional development activities.",
      "specializations": [
        "Thermal Engineering",
        "Heat transfer",
        "Fluid dynamics"
      ],
      "areas": [
        "Thermal Engineering",
        "Heat transfer",
        "Fluid dynamics"
      ],
      "courses": [
        "Basic Thermodynamics",
        "Heat Transfer",
        "Advanced Power Cycle Analysis",
        "Design Of Heat Transfer Equipments"
      ],
      "publications": 6,
      "projects": 0,
      "linkedin": "https://linkedin.com/in/ranganath-patil-5a91a19b",
      "irins": "https://klsvdit.irins.org/profile/248949",
      "recognition": [
        "Served as Head of Department (HOD) of Mechanical Engineering, Research Co Ordinator, Academic coordinator",
        "Completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) Certificate Program on Cyber Physical System at Indian Institute of Information Technology (IIIT), Dharwad"
      ]
    },
    {
      "id": "f-gururaj-h-joshi",
      "name": "Mr. Gururaj H Joshi",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.E., (Ph.D.)",
      "qualifications": "M.E., (Ph.D.)",
      "image": "/FacultyCImages/gururaj_joshi_MECh.jpeg",
      "email": "ghj@klsvdit.edu.in",
      "phone": "+91 94484 20102",
      "showPhone": false,
      "experience": "27 years",
      "description": "Mr. Gururaj H. Joshi is an Assistant Professor in the Department of Mechanical Engineering at KLS VDIT. He holds a Bachelor's degree from Karnataka University and a Master's degree in Machine Design from Bangalore University. With four years of industrial and 25 years of teaching experience, he actively guides undergraduate and postgraduate projects.",
      "bio": "Mr. Gururaj H. Joshi is an Assistant Professor in the Department of Mechanical Engineering at KLS VDIT. He holds a Bachelor's degree from Karnataka University and a Master's degree in Machine Design from Bangalore University. With four years of industrial and 25 years of teaching experience, he actively guides undergraduate and postgraduate projects.",
      "specializations": [
        "Dynamics Of Machines",
        "Vibration of Rotating Machines"
      ],
      "areas": [
        "Dynamics Of Machines",
        "Vibration of Rotating Machines"
      ],
      "courses": [
        "Mechanics Of Materials",
        "Finite Element Analysis",
        "Control Systems",
        "Engineering Drawing"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/search/results/all/?keywords=Gururaj+Joshi+KLSVDIT+Haliyal&utm_source=chatgpt.com",
      "irins": "https://klsvdit.irins.org/profile/248972",
      // "recognition": [
      //   "Visvesvaraya Technological Univ. Belagavi",
      //   "Member, Institution of Engineers India (IEI)"
      // ]
    },
    {
      "id": "f-shylesha-channapattana",
      "name": "Dr.Shylesha V Channapattana",
      "designation": "Professor",
      "role": "Professor",
      "qualification": "M.Tech., Ph.D.",
      "qualifications": "M.Tech., Ph.D",
      "image": "/FacultyCImages/Shylesha_Channapattana.jpg",
      "email": "svc@klsvdit.edu.in",
      "phone": "+91 9404230733",
      "showPhone": false,
      "experience": "32 years",
      "description": "Dr. Shylesha Channapattana is a distinguished Mechanical Engineering academic with over 32 years of teaching, research, and administrative experience. His research focuses on renewable energy, photovoltaic-thermal systems, nanofluids, alternative fuels, and condition monitoring. He has published papers in reputed Q1/Q2 journals, secured patents, reviewed international journals, guided research scholars, and received recognition for his contributions to engineering education and innovation.",
      "bio": "Dr. Shylesha Channapattana is a distinguished Mechanical Engineering academic with over 32 years of teaching, research, and administrative experience. His research focuses on renewable energy, photovoltaic-thermal systems, nanofluids, alternative fuels, and condition monitoring. He has published papers in reputed Q1/Q2 journals, secured patents, reviewed international journals, guided research scholars, and received recognition for his contributions to engineering education and innovation.",
      "specializations": [
        "Heat Transfer Enhancement",
        "Renewable Energy",
        "Alternative Fuels for IC Engines",
        "Optimization"
      ],
      "areas": [
        "Heat Transfer Enhancement",
        "Renewable Energy",
        "Alternative Fuels for IC Engines",
        "Optimization"
      ],
      "courses": [
        "Heat Transfer",
        "Thermodynamics",
        "TQM",
        "Renewable Energy Source utilisation"
      ],
      "publications": 55,
      "projects": 8,
      "linkedin": "https://linkedin.com/in/dr-shylesha-channapattana-7043617",
      "irins": "https://klsvdit.irins.org/profile/259192",
      "recognition": [
        "Outstanding Research Publications award by VGST Govt. of Karnataka State;BoS Member ME VTU for 2022-25 and 2025-28",
       
      ]
    }
  ]
};

export default facultyData;